<template>
    <main>
        <Trail />
        <Container class="container--main">
            <Row>
                <ColumnUi md="9">
                    <Title tag="h1">{{ title }}</Title>
                    <Input label="Buscar" type="text" @getValue="getQuery" v-if="filteredProjects && filteredProjects.data"/>
                    <TableUi v-if="filteredProjects && filteredProjects.data">
                        <template v-slot:header>
                            <tr>
                                <th>Título</th>
                                <th></th>
                            </tr>
                        </template>
                        <template v-slot:body>
                            <tr v-for="(project, index) in filteredProjects.data" :key="index">
                                <td>{{ project.title }}</td>
                                <td>
                                    <Button tag="button" theme="primary" @click="openModal(project)">Ver proyecto</Button>
                                </td>
                            </tr>
                        </template>
                    </TableUi>
                    <p v-else>
                        No se encontraron proyectos
                    </p>
                </ColumnUi>
                <ColumnUi md="3">
                    <h3>En esta sección</h3>
                    <List marked>
                        <li v-for="(projectType, index) in projectTypes" :key="index">
                        <router-link
                            v-if="type != projectType.slug"
                            :to="`/proyectos/${projectType.slug}`"
                        >
                            {{ projectType.title }}
                        </router-link>
                        <span v-else>
                            {{ projectType.title }}
                        </span>
                        </li>
                    </List>
                </ColumnUi>
            </Row>
        </Container>
        <Modal :showModal="showModal" centered v-on:close="close">
            <template v-slot:header>
                <h3>{{ showProject.data.title }}</h3>
            </template>
            <template v-slot:body>
                <!-- {{ modal.body }} -->
                <section v-if="showProject.data.leaders && showProject.data.leaders.length">
                    <b>Responsable</b>
                    <p>
                        <template v-for="(leader, index) in showProject.data.leaders" :key="index">
                            <template v-if="index == (showProject.data.leaders.length - 1)">{{ leader }}</template>
                            <template v-else>{{ leader }}, </template>
                        </template>
                    </p>

                </section>
                <section v-if="showProject.data.abstract">
                    <b>Resumen</b>
                    <Content :content="showProject.data.abstract"/>
                </section>
                <section v-if="showProject.data.team">
                    <b>Colaboradores</b>
                    <p>
                        <template v-for="(teammate, index) in showProject.data.team" :key="index">
                            <template v-if="index == (showProject.data.team.length - 1)">{{ teammate }}</template>
                            <template v-else>{{ teammate }}, </template>
                        </template>
                    </p>
                </section>
                <section v-if="showProject.data.support || showProject.data.management">
                    <p>
                        <span v-if="showProject.data.support && showProject.data.support.length">Personal de apoyo: </span>
                        <template v-for="(supporter, index) in showProject.data.support" :key="index">
                            <template v-if="index == (showProject.data.support.length - 1)">{{ supporter }}</template>
                            <template v-else>{{ supporter }}, </template>
                        </template>
                        <br v-if="showProject.data.support && showProject.data.support.length"/>
                        <span v-if="showProject.data.management && showProject.data.management.length">Personal administrativo: </span>
                        <template v-for="(manager, index) in showProject.data.management" :key="index">
                            <template v-if="index == (showProject.data.management.length - 1)">{{ manager }}</template>
                            <template v-else>{{ manager }}, </template>
                        </template>
                    </p>
                </section>
            </template>
        </Modal>
    </main>
</template>
<script>
import {getProjects} from "@/projects.js";
import { useRoute } from 'vue-router';
import Container from "@/components/ui/objects/Container.vue";
import Title from "@/components/ui/atoms/Title.vue";
import Trail from "@/components/common/Trail.vue";
import Button from "@/components/ui/atoms/Button.vue";
import TableUi from "@/components/ui/objects/TableUi.vue"
import Modal from "@/components/common/Modal.vue";
import Content from '../components/common/Content.vue';
import Row from '../components/ui/atoms/Row.vue';
import ColumnUi from '../components/ui/atoms/ColumnUi.vue';
import List from '../components/ui/objects/List.vue';
import Input from "@/components/ui/atoms/Input"

import { reactive, ref, watch } from 'vue';

export default {
    components: {
        Trail,
        Container,
        Input,
        TableUi,
        Title,
        Button,
        Modal,
        Content,
        Row,
        ColumnUi,
        List,
    },
    emits: ['setOverlay'],
    setup(props, { emit }) {
        const filter = ref("");
        const type = useRoute().params.type;
        const allProjects = getProjects(process.env.VUE_APP_PREFIX);
        const singleTypeProjects = allProjects.find(projects => projects.slug == type);
        const title = singleTypeProjects && singleTypeProjects.type || `No se encontraron los proyectos ${type}`
        const projectTypes = []
        allProjects.forEach(e => {
            projectTypes.push({slug: e.slug, title: e.type});
        });



        let showModal = ref(false);
        let showProject = reactive({ data: {} });
        const openModal = (project) => {
            showModal.value = true;
            showProject.data = project;
        }
        const close = () => {
            showModal.value = false
        }

        let filteredProjects = singleTypeProjects && reactive({ data:singleTypeProjects.data }) || [];
        const getQuery = (query) => {
            filter.value = query;
            filterProjects();
        }
        function filterProjects() {
            filteredProjects.data = singleTypeProjects.data.filter(project => project.title.toLowerCase().includes(filter.value.toLowerCase()));
        }
        
        watch(showModal, () => { emit('setOverlay', showModal.value) })
        return {
            title,
            filteredProjects,
            showModal,
            showProject,
            openModal,
            close,
            projectTypes,
            type,
            getQuery
        }
    }
}
</script>